import { gameAction } from "_actions";
import { GameService } from "_services";
import React, { useEffect, useState, useRef } from "react";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import ScrollableListView from "../ScrollableListView";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { ServiceURLs } from "_services";
import i18n from "i18n";
import CryptoJS from "crypto-js";
import { isMobile } from "react-device-detect";

const MOBILE_URL = "https://m.betdaxwin.com/";
const DESKTOP_URL = "https://sportsbook.betdaxwin.com/";
const MODE = "/sports/live/event-view?integrationMode=1";

const SportsbookLive = (props) => {
  const { user, loggedIn, sports, games, UpdateGames, demo } = props;
  
  // Cihaz tipine göre URL seçimi
  const getInitialUrl = () => {
    return isMobile ? MOBILE_URL : DESKTOP_URL;
  };
  
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(getInitialUrl());
  const iframeRef = useRef(null);
  const containerRef = useRef(null);

  const [jti, setJti] = useState(null);
  const [iframeHeight, setIframeHeight] = useState('100vh');
  const [iframeTop, setIframeTop] = useState(0);

  function GetParams() {
    let params = useParams();
    return params;
  }
  let params = GetParams();



  let startget = false;


  /*
  const adjustHeight = () => {
    const windowHeight = window.innerHeight;
     try {
      document.querySelector(".gameiframe").style.height = `${windowHeight}px`;
    } catch (error) {
      
    }
  };

  useEffect(() => {
    window.addEventListener("DOMContentLoaded", adjustHeight);
    window.addEventListener("resize", adjustHeight);
  }, []);
*/

// Tarayıcı uyumlu MD5 hash fonksiyonu
const md5 = (data) => {
  // String'e çevir (eğer değilse)
  const dataString = typeof data === 'string' ? data : JSON.stringify(data);
  // crypto-js ile MD5 hash oluştur
  return CryptoJS.MD5(dataString).toString();
};

  function openInNewTab(url) {
    var newWindow = window.open(url);
    newWindow.focus();
  }

  // iframe'e postMessage gönderme fonksiyonu
  const sendMessageToIframe = (message, targetOrigin = "*") => {
    if (iframeRef.current && iframeRef.current.contentWindow) {
      iframeRef.current.contentWindow.postMessage(message, targetOrigin);
    }
  };

  // Login işlemi için özel fonksiyon
  const restoreLogin = () => {
    const userId = user.RelUser._id || user.user_id || user.userId || ""; // User ID alanını user objesine göre ayarlayın
    const _jti = getJti();
    setJti(_jti);
    debugger
    if (iframeRef.current && iframeRef.current.contentWindow) {
      iframeRef.current.contentWindow.postMessage(
        {
          action: "restore_login",
          data: {
            auth_token: _jti,
            user_id: userId
          }
        },
        "*"
      );
    }
  };

  const setPreferences = () => {
    const win = iframeRef.current?.contentWindow;
    if (!win) return;

    win.postMessage(
      {
        action: "setPreferences",
        data: {
          language: "en",
        },
      },
      '*'
    );
  };
  // iframe'den gelen mesajları dinleme

  const getJti = () => {
    const authToken = localStorage.getItem("access_token");
    const jwt = parseJWT(authToken);
    if (jwt && jwt.payload) {
      const _jti = md5(jwt.payload.jti || jwt.payload.JTI);
      setJti(_jti);
      return _jti;
    }
    return null;
  }

  // Header yüksekliğini hesaplayıp iframe konumunu ve yüksekliğini ayarla
  useEffect(() => {
    const adjustIframePosition = () => {
      try {
        // Header yüksekliklerini al
        const navbarHeight = document.querySelector(".base-nav")?.offsetHeight || 0;
        const navbarHeight1 = document.querySelector(".base-nav1")?.offsetHeight || 0;
        
        // En yüksek header'ı kullan
        const maxHeaderHeight = Math.max(navbarHeight, navbarHeight1);
        
        // iOS Safari için gerçek viewport height'ı kullan
        const windowHeight = window.innerHeight;
        const actualHeight = windowHeight - maxHeaderHeight;
        
        // State'leri güncelle
        setIframeTop(maxHeaderHeight);
        setIframeHeight(`${actualHeight}px`);
        
        // Container'a da stil ver
        if (containerRef.current) {
          containerRef.current.style.top = `${maxHeaderHeight}px`;
          containerRef.current.style.height = `${actualHeight}px`;
        }
      } catch (error) {
        console.error("Iframe position adjustment error:", error);
      }
    };

    // İlk yüklemede ayarla (DOM hazır olduğunda)
    const timer = setTimeout(adjustIframePosition, 100);
    
    // Resize ve orientation change event'lerini dinle
    window.addEventListener('resize', adjustIframePosition);
    window.addEventListener('orientationchange', () => {
      // Orientation değiştiğinde kısa bir gecikme ile tekrar ayarla
      setTimeout(adjustIframePosition, 200);
    });
    
    // DOMContentLoaded event'ini de dinle
    window.addEventListener('DOMContentLoaded', adjustIframePosition);

    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', adjustIframePosition);
      window.removeEventListener('orientationchange', adjustIframePosition);
      window.removeEventListener('DOMContentLoaded', adjustIframePosition);
    };
  }, []);

  // Cihaz tipine göre URL'i güncelle
  useEffect(() => {
    const updateUrl = () => {
      const shouldUseMobile = isMobile || window.innerWidth < 768;
      setData(shouldUseMobile ? MOBILE_URL : DESKTOP_URL);
    };

    // İlk yüklemede kontrol et
    updateUrl();

    // Ekran boyutu değişikliklerini dinle (opsiyonel)
    const handleResize = () => {
      updateUrl();
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    restoreLogin();
  }, [loggedIn, user]);


  // Base64URL decode fonksiyonu (tarayıcı uyumlu)
  const base64UrlDecode = (str) => {
    // Base64URL'yi standart Base64'e çevir
    let base64 = str.replace(/-/g, '+').replace(/_/g, '/');

    // Padding ekle
    while (base64.length % 4) {
      base64 += '=';
    }

    // atob ile decode et ve JSON parse için hazırla
    try {
      const decoded = atob(base64);
      return decoded;
    } catch (error) {
      console.error("Base64 decode hatası:", error);
      return null;
    }
  };

  const parseJWT = (token) => {
    try {
      if (!token) return null;

      const [headerB64, payloadB64, signature] = token.split(".");

      if (!headerB64 || !payloadB64) {
        console.error("Geçersiz JWT formatı");
        return null;
      }

      // Base64URL decode
      const headerDecoded = base64UrlDecode(headerB64);
      const payloadDecoded = base64UrlDecode(payloadB64);

      if (!headerDecoded || !payloadDecoded) {
        return null;
      }

      const header = JSON.parse(headerDecoded);
      const payload = JSON.parse(payloadDecoded);

      return { header, payload, signature };
    } catch (error) {
      console.error("JWT parse hatası:", error);
      return null;
    }
  }
  useEffect(() => {
    const handleMessage = (event) => {
      // Güvenlik: Sadece belirli origin'den gelen mesajları kabul et
      // const allowedOrigin = "https://sportsbook.betdaxwin.com";
      // if (event.origin !== allowedOrigin) return;

      // iframe'den gelen mesajı işle

      // Örnek: Mesaj tipine göre işlem yap
      if (event.data && event.data.type) {
        switch (event.data.type) {
          case "app_ready":
             // İframe hazır olduğunda mesaj gönderebilirsiniz
            // sendMessageToIframe({ type: "setPreferences", data: { language: "en" } });
            //    setPreferences();
            break;
          case "CLOSE":
             break;
          case "login":
            // Open the login popup
            //openLoginPopup();
            //  alert("login");
            restoreLogin();
            break;
          case "register":
            // Open the registration popup
            // openRegistrationPopup();
            alert("register");
            break;
          case "deposit":
            // Navigate to the deposit page
            //  goToDepositPage();
            alert("deposit");
            break;
          default:
             break;
        }
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [user]);

  // iframe yüklendiğinde ve kullanıcı giriş yaptığında login mesajı gönder
  useEffect(() => {
    if (data && iframeRef.current && loggedIn && user) {
      const iframe = iframeRef.current;
      const handleLoad = () => {
        // İframe yüklendiğinde INIT mesajı gönder
        // sendMessageToIframe({ type: "setPreferences", data: { language: props.currentLang } });
        /* sendMessageToIframe({
           type: "INIT",
           data: {
             user: user,
             language: props.currentLang
           }
         });*/

        // Login işlemi için restore_login mesajı gönder
        // auth_token ve user_id değerlerini user objesinden alabilirsiniz


        restoreLogin();

      };

      // Eğer iframe zaten yüklendiyse hemen çalıştır
      if (iframe.contentDocument && iframe.contentDocument.readyState === "complete") {
        handleLoad();
      } else {
        iframe.addEventListener("load", handleLoad);
      }

      return () => {
        iframe.removeEventListener("load", handleLoad);
      };
    }
  }, [data, loggedIn, user, props.currentLang]);

  return (
    <Translation>
      {(t) => (
        <>
          <Helmet>
            <title>{t("TITLE_CASINO")}</title>
            <style type="text/css">
              {`
      body, html , #root{
        height: 100%;
        margin: 0;
        overflow: hidden;
        padding-bottom: 0px !important;
        position: relative;
      }
      .appdiv{
        height: 100% !important;
      }
      .sportsbook-iframe-container {
        position: fixed;
        left: 0;
        width: 100%;
        overflow: hidden;
        margin: 0;
        padding: 0;
        z-index: 1;
      }
      .sportsbook-iframe-container iframe {
        width: 100%;
        height: 100%;
        border: none;
        display: block;
        margin: 0;
        padding: 0;
      }
      
      
    `}
            </style>
          </Helmet>
          {data && (
            <div 
              ref={containerRef} 
              className="sportsbook-iframe-container" 
              style={{ 
                top: `${iframeTop}px`,
                height: iframeHeight 
              }}
            >
              <iframe 
                ref={iframeRef} 
                src={`${data + `${props.currentLang=="krt"?"ku":props.currentLang}` + MODE + "&oddsType=decimal"+(jti ? `&AuthToken=${jti}` : "")+ (props.user ? `&UserId=${props.user.RelUser._id}` : "")}`}
                style={{ height: '100%' }}
              />
            </div>
          )}
        </>
      )}
    </Translation>
  );
};
// height: "calc(100vh - 72px)",
const mapStateToProps = (state, props) => {
  const { authentication, game } = state;
  const { user, loggedIn, currentLang } = authentication;
  const { sports, games } = game;
  return {
    user,
    loggedIn,
    sports,
    games,
    currentLang,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    UpdateGames: (data) => dispatch(gameAction.UpdateGamesData(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SportsbookLive);
